<header [ngClass]="combineClassNames()">
  <div class="mainContainer">
    <div class="menuDeskTopFlexRow">
      <div class="logoDivFlexRow">
        <a routerLink="/" class="commonLoginIcon">
          <div class="headerltr">
            <img src="../../assets/images/infinthra-whitetext-logo.svg" alt="">
          </div>
          <div class="headerrtl">
            <img src="../../assets/images/infinthra-whitetext-logo-ar.svg" alt="">
          </div>
        </a>
        <a routerLink="/" class="loginIconBlog">
          <!-- <img [src]="'header.blueTextLogo' | translate" alt="Logo" loading="lazy" /> -->

          <div class="headerltr">
            <img width="453" height="113" src="../../assets/images/infinthra-bluetext-logo.webp" alt="">
          </div>
          <div class="headerrtl">
            <img src="../../assets/images/infinthra-bluetext-logo-ar-new.svg" alt="">
          </div>

        </a>



        <nav role="navigation">
          <ul class="main-nav">
            <li class="top-level-link">
              <a class="mega-menu" (mouseenter)="handleViewSub('product')">
                <span *ngIf="(translate.get('header.navigation.products') | async)">{{ 'header.navigation.products' |
                  translate }}
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>

                </span>
                <span *ngIf="!(translate.get('header.navigation.products') | async)">Products
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>

                </span>
              </a>
              <div *ngIf="productSubBlock" class="sub-menu-block">
                <div class="productsMenuDivRow">
                  <div class="productsMenuIconFloat1">
                    <a class="iconWrapperMainFlex1" routerLink="/core-hr">
                      <div class="iconWrapper1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M11.1667 9.4671V4.08377C11.1667 3.46044 10.6567 2.95044 10.0334 2.95044H7.4834"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M8.90019 1.53369L7.2002 2.95036L8.90019 4.36702" stroke="white" stroke-width="0.9375"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M3.2334 5.50049V9.46715" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.37511 5.21702C4.39224 5.21702 5.21678 4.39248 5.21678 3.37536C5.21678 2.35823 4.39224 1.53369 3.37511 1.53369C2.35799 1.53369 1.53345 2.35823 1.53345 3.37536C1.53345 4.39248 2.35799 5.21702 3.37511 5.21702Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.23345 12.867C4.17233 12.867 4.93345 12.1059 4.93345 11.167C4.93345 10.2282 4.17233 9.46704 3.23345 9.46704C2.29456 9.46704 1.53345 10.2282 1.53345 11.167C1.53345 12.1059 2.29456 12.867 3.23345 12.867Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M11.1668 12.867C12.1057 12.867 12.8668 12.1059 12.8668 11.167C12.8668 10.2282 12.1057 9.46704 11.1668 9.46704C10.2279 9.46704 9.4668 10.2282 9.4668 11.167C9.4668 12.1059 10.2279 12.867 11.1668 12.867Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <a routerLink="/core-hr">

                        <div (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                          <h3>{{ 'header.navigation.subMenus.products.items.coreHR.title' | translate }}</h3>
                          <p>{{ 'header.navigation.subMenus.products.items.coreHR.description' | translate }}</p>
                        </div>
                      </a>
                    </a>

                    <a class="iconWrapperMainFlex2" routerLink="/employee-management">
                      <div class="iconWrapper2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <circle cx="7.19975" cy="7.2" r="6.73125" fill="white" fill-opacity="0.22" stroke="white"
                            stroke-width="0.9375" />
                          <path
                            d="M7.19933 6.47993C8.12584 6.47993 8.87693 5.72884 8.87693 4.80232C8.87693 3.87581 8.12584 3.12476 7.19933 3.12476C6.27282 3.12476 5.52173 3.87581 5.52173 4.80232C5.52173 5.72884 6.27282 6.47993 7.19933 6.47993Z"
                            fill="#81B2FF" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M10.0796 10.5554C10.0796 9.25941 8.79078 8.20825 7.19958 8.20825C5.60838 8.20825 4.31958 9.25941 4.31958 10.5554"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.employeeManagement.title' | translate }}</h3>
                        <p>{{ 'header.navigation.subMenus.products.items.employeeManagement.description' | translate }}
                        </p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex3" routerLink="/attendance-management">
                      <div class="iconWrapper3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M13.2002 7.69995C13.2002 11.0119 10.5122 13.6999 7.20019 13.6999C3.88819 13.6999 1.2002 11.0119 1.2002 7.69995C1.2002 4.38795 3.88819 1.69995 7.20019 1.69995C10.5122 1.69995 13.2002 4.38795 13.2002 7.69995Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M9.42627 9.6081L7.56627 8.4981C7.24227 8.3061 6.97827 7.8441 6.97827 7.4661V5.0061"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div a routerLink="/attendance-management" (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.timeAttendance.title' | translate }}</h3>
                        <p>{{ 'header.navigation.subMenus.products.items.timeAttendance.description' | translate }}</p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex4" routerLink="/leave-management">
                      <div class="iconWrapper4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M12.5998 5.59961V10.6996C12.5998 12.4996 11.6998 13.6996 9.5998 13.6996H4.7998C2.6998 13.6996 1.7998 12.4996 1.7998 10.6996V5.59961C1.7998 3.79961 2.6998 2.59961 4.7998 2.59961H9.5998C11.6998 2.59961 12.5998 3.79961 12.5998 5.59961Z"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M12.5998 5.59985V10.6998C12.5998 12.4998 11.6998 13.6998 9.5998 13.6998H4.7998C2.6998 13.6998 1.7998 12.4998 1.7998 10.6998V5.59985C1.7998 3.79985 2.6998 2.59985 4.7998 2.59985H9.5998C11.6998 2.59985 12.5998 3.79985 12.5998 5.59985Z"
                            stroke="white" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M2.1001 5.9541H12.3001" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.7998 1.7002V3.50019" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.6001 1.7002V3.50019" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.41682 8.71992H9.42221" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M9.41682 10.52H9.42221" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M7.19709 8.71992H7.20248" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M7.19709 10.52H7.20248" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.97639 8.71992H4.98178" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.97639 10.52H4.98178" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div routerLink="/leave-management" (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.leaveManagement.title' | translate }}</h3>
                        <p>{{ 'header.navigation.subMenus.products.items.leaveManagement.description' | translate }}</p>
                      </div>
                    </a>
                  </div>

                  <div class="productsMenuIconFloat1 productsMenuIconFloat2">
                    <a class="iconWrapperMainFlex5" routerLink="/payroll-management">
                      <div class="iconWrapper5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M10.8235 8.63014C10.5715 8.87614 10.4275 9.23014 10.4635 9.60814C10.5175 10.2561 11.1115 10.7301 11.7595 10.7301H12.8995V11.4441C12.8995 12.6861 11.8855 13.7001 10.6435 13.7001H3.75551C2.51351 13.7001 1.49951 12.6861 1.49951 11.4441V7.40615C1.49951 6.16415 2.51351 5.15015 3.75551 5.15015H10.6435C11.8855 5.15015 12.8995 6.16415 12.8995 7.40615V8.27015H11.6875C11.3515 8.27015 11.0455 8.40214 10.8235 8.63014Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M1.49951 7.94618V5.20421C1.49951 4.49021 1.93751 3.85418 2.60351 3.60218L7.36751 1.80218C8.11151 1.52018 8.90951 2.0722 8.90951 2.8702V5.15019"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M13.5347 8.88199V10.118C13.5347 10.448 13.2707 10.718 12.9347 10.73H11.7587C11.1107 10.73 10.5167 10.256 10.4627 9.60801C10.4267 9.23001 10.5707 8.876 10.8227 8.63C11.0447 8.402 11.3507 8.27002 11.6867 8.27002H12.9347C13.2707 8.28202 13.5347 8.55199 13.5347 8.88199Z"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.19946 7.69995H8.39946" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div routerLink="/payroll-management" (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.payrollManagement.title' | translate }}</h3>
                        <p>{{ 'header.navigation.subMenus.products.items.payrollManagement.description' | translate }}
                        </p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex6" routerLink="/people-analytics">
                      <div class="iconWrapper6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M11.5559 11.8398V4.75976C11.5559 3.85976 11.1719 3.49976 10.2179 3.49976H9.59386C8.63986 3.49976 8.25586 3.85976 8.25586 4.75976V11.8398"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M11.5559 11.8398V4.75976C11.5559 3.85976 11.1719 3.49976 10.2179 3.49976H9.59386C8.63986 3.49976 8.25586 3.85976 8.25586 4.75976V11.8398"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M3.15576 11.8402V7.76024C3.15576 6.86024 3.53976 6.50024 4.49376 6.50024H5.11776C6.07176 6.50024 6.45576 6.86024 6.45576 7.76024V11.8402"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M3.15576 11.8402V7.76024C3.15576 6.86024 3.53976 6.50024 4.49376 6.50024H5.11776C6.07176 6.50024 6.45576 6.86024 6.45576 7.76024V11.8402"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1.2002 11.9001H13.2002" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.peopleAnalytics.title' | translate }}</h3>
                        <p>{{ 'header.navigation.subMenus.products.items.peopleAnalytics.description' | translate }}</p>
                      </div>

                    </a>

                    <a class="iconWrapperMainFlex8" (click)="isDisabled ? $event.preventDefault() : null">
                      <div class="iconWrapper8">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M6.2 14H9.8C12.8 14 14 12.8 14 9.8V6.2C14 3.2 12.8 2 9.8 2H6.2C3.2 2 2 3.2 2 6.2V9.8C2 12.8 3.2 14 6.2 14Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M8.22156 6.12793H11.3716H8.22156Z" fill="white" fill-opacity="0.22" />
                          <path d="M8.22156 6.12793H11.3716" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.6283 6.12778L5.0783 6.57778L6.4283 5.22778" stroke="white" stroke-width="0.9375"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M8.22156 10.3279H11.3716H8.22156Z" fill="white" fill-opacity="0.22" />
                          <path d="M8.22156 10.3279H11.3716" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.6283 10.328L5.0783 10.778L6.4283 9.42798" stroke="white" stroke-width="0.9375"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.performanceManagement.title' | translate }}
                          <!-- <sup>{{ 'header.navigation.subMenus.products.items.performanceManagement.sup' | translate
                            }}</sup> -->
                        </h3>
                        <p>{{ 'header.navigation.subMenus.products.items.performanceManagement.description' | translate
                          }}</p>
                      </div>

                    </a>

                    <a class="iconWrapperMainFlex7" (click)="isDisabled ? $event.preventDefault() : null">
                      <div class="iconWrapper7">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M10.8002 4.79595C10.7642 4.78995 10.7222 4.78995 10.6862 4.79595C9.85824 4.76595 9.19824 4.08795 9.19824 3.24795C9.19824 2.38995 9.88824 1.69995 10.7462 1.69995C11.6042 1.69995 12.2942 2.39595 12.2942 3.24795C12.2882 4.08795 11.6282 4.76595 10.8002 4.79595Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M10.1822 9.16405C11.0042 9.30205 11.9102 9.15805 12.5462 8.73205C13.3922 8.16805 13.3922 7.24405 12.5462 6.68005C11.9042 6.25405 10.9862 6.11004 10.1642 6.25404"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M10.1822 9.16405C11.0042 9.30205 11.9102 9.15805 12.5462 8.73205C13.3922 8.16805 13.3922 7.24405 12.5462 6.68005C11.9042 6.25405 10.9862 6.11004 10.1642 6.25404"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M3.58226 4.79595C3.61826 4.78995 3.66026 4.78995 3.69626 4.79595C4.52426 4.76595 5.18426 4.08795 5.18426 3.24795C5.18426 2.38995 4.49426 1.69995 3.63626 1.69995C2.77826 1.69995 2.08826 2.39595 2.08826 3.24795C2.09426 4.08795 2.75426 4.76595 3.58226 4.79595Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M4.20016 9.16405C3.37816 9.30205 2.47216 9.15805 1.83616 8.73205C0.99016 8.16805 0.99016 7.24405 1.83616 6.68005C2.47816 6.25405 3.39616 6.11004 4.21816 6.25404"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M4.20016 9.16405C3.37816 9.30205 2.47216 9.15805 1.83616 8.73205C0.99016 8.16805 0.99016 7.24405 1.83616 6.68005C2.47816 6.25405 3.39616 6.11004 4.21816 6.25404"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M7.20026 9.27789C7.16426 9.27189 7.12227 9.27189 7.08627 9.27789C6.25827 9.24789 5.59827 8.56989 5.59827 7.72989C5.59827 6.87189 6.28827 6.18188 7.14626 6.18188C8.00426 6.18188 8.69427 6.87789 8.69427 7.72989C8.68827 8.56989 8.02826 9.25389 7.20026 9.27789Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M5.4542 11.1679C4.6082 11.7319 4.6082 12.6559 5.4542 13.2199C6.4142 13.8619 7.9862 13.8619 8.9462 13.2199C9.7922 12.6559 9.7922 11.7319 8.9462 11.1679C7.9922 10.5319 6.4142 10.5319 5.4542 11.1679Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div (click)="handleRemoveSubBlock()" class="iconWrapper1Text">
                        <h3>{{ 'header.navigation.subMenus.products.items.recruitment.title' | translate }} <sup>{{
                            'header.navigation.subMenus.products.items.recruitment.sup' | translate }}</sup></h3>
                        <p>{{ 'header.navigation.subMenus.products.items.recruitment.description' | translate }}</p>
                      </div>
                    </a>

                    
                  </div>
                </div>

                <a routerLink="/employee-self-service">
                  <div class="ess-banner">
                    <img class="patternPosBottom" alt="pattern" width="100%"
                      src="../../assets/images/header-Ess-banner.svg" />
                    <div class="ess-banner-content">
                      <h2>{{ 'header.navigation.subMenus.products.essBanner.title' | translate }}</h2>
                      <button class="sceduleDemoBtn" (click)="redirectToEss()">
                        <i>{{ 'header.navigation.subMenus.products.essBanner.button' | translate }}</i>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none">
                            <path d="M4.1202 11.6104L18.2869 11.6104" stroke="white" stroke-width="1.66667"
                              stroke-linecap="round"></path>
                            <path d="M13.0013 17.7285L19.1206 11.6092L13.0259 5.51447" stroke="white"
                              stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg></span>
                      </button>
                    </div>
                    <img src="../../assets/images/infithra-employee-self-service-app.svg" alt="Mascot"
                      class="ess-banner-image">
                  </div>
                </a>

                <div class="bgmenuSubBgBottom">
                  <ul>
                    <li><a routerLink="/contact-us">{{ 'header.navigation.subMenus.products.contactUs' | translate
                        }}</a></li>
                    <li><a routerLink='/demo' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.products.scheduleDemo' | translate
                        }}</a></li>
                    <li><a routerLink='/product-tour' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.products.productTour' | translate
                        }}</a></li>
                    <li><a routerLink='/HR-Software'>{{
                        'header.navigation.subMenus.products.HRSoftware' | translate
                        }}</a></li>
                    <!-- <li><a>{{ 'header.navigation.subMenus.products.learnMore' | translate }}</a></li>  FUTURE USE-->
                  </ul>
                </div>
              </div>
            </li>

            <li class="top-level-link">
              <a class="mega-menu" (mouseenter)="handleViewSub('solution')">
                <span *ngIf="(translate.get('header.navigation.solutions') | async)">{{ 'header.navigation.solutions' |
                  translate }}
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>

                <span *ngIf="!(translate.get('header.navigation.solutions') | async)">Solutions
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>
              </a>
              <div *ngIf="solutionSubBlock" class="sub-menu-block">
                <div class="productsMenuDivRow1">
                  <div class="bussinesFloat1Row">
                    <div class="bussinessCaseDiv">
                      <a [routerLink]="['/use-cases']" fragment='business-size'>
                        <div class="commonHeaderDivRow">
                          <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                              fill="none">
                              <path
                                d="M7.80001 13.2H3.00001C1.80001 13.2 1.20001 12.6 1.20001 11.4V6.60005C1.20001 5.40005 1.80001 4.80005 3.00001 4.80005H6.00001V11.4C6.00001 12.6 6.60001 13.2 7.80001 13.2Z"
                                stroke="white" stroke-width="0.88" stroke-miterlimit="10" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path
                                d="M6.06599 2.3999C6.01799 2.5799 6 2.7779 6 2.9999V4.7999H3V3.5999C3 2.9399 3.54 2.3999 4.2 2.3999H6.06599Z"
                                fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.88"
                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.40002 4.80005V7.80005" stroke="white" stroke-width="0.88"
                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M10.8 4.80005V7.80005" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M3.60004 7.80005V10.2" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M6 11.4V2.99995C6 1.79995 6.6 1.19995 7.8 1.19995H11.4C12.6 1.19995 13.2 1.79995 13.2 2.99995V11.4C13.2 12.6 12.6 13.2 11.4 13.2H7.8C6.6 13.2 6 12.6 6 11.4Z"
                                fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.88"
                                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M10.2 10.2H9.00002C8.67002 10.2 8.40002 10.47 8.40002 10.8V13.2H10.8V10.8C10.8 10.47 10.53 10.2 10.2 10.2Z"
                                fill="#3A86FF" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                            </svg></span>
                          <h3>{{ 'header.navigation.subMenus.solutions.items.businessSize.title' | translate }}</h3>
                        </div>
                      </a>
                      <div class="commonTxtDiv">
                        <a [routerLink]="['/use-cases']" fragment='business-size'>
                          <div (click)="handleRemoveSubBlock()" class="linkMain1">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.startups.title' |
                              translate }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.startups.description' |
                              translate }}</p>
                          </div>
                        </a>
                        <a [routerLink]="['/use-cases']" fragment='business-size'>
                          <div (click)="handleRemoveSubBlock()" class="linkMain1">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.smes.title' |
                              translate
                              }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.smes.description' |
                              translate }}</p>
                          </div>
                        </a>

                        <a [routerLink]="['/use-cases']" fragment='business-size'>
                          <div (click)="handleRemoveSubBlock()" class="linkMain1">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.enterprise.title' |
                              translate }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.enterprise.description'
                              |
                              translate }}</p>
                          </div>
                        </a>



                      </div>
                    </div>

                    <div class="userCaseDiv">
                      <a class="commonHeaderDivRow" routerLink="/use-cases">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                            fill="none">
                            <path
                              d="M4.80001 4.19995L4.80001 2.39995C4.80001 1.73995 4.26001 1.19995 3.60001 1.19995L2.40001 1.19995C1.74001 1.19995 1.20001 1.73995 1.20001 2.39995L1.20001 4.19995C1.20001 4.85995 1.74001 5.39995 2.40001 5.39995L3.60001 5.39995C4.26001 5.39995 4.80001 4.85995 4.80001 4.19995Z"
                              stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M4.20002 12.4799L4.20002 10.3199C4.20002 9.92385 3.87601 9.59985 3.48001 9.59985L2.52003 9.59985C2.12403 9.59985 1.80002 9.92385 1.80002 10.3199L1.80002 12.4799C1.80002 12.8759 2.12403 13.1999 2.52003 13.1999L3.48001 13.1999C3.87601 13.1999 4.20002 12.8759 4.20002 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M8.70002 12.4799L8.70002 10.3199C8.70002 9.92385 8.37601 9.59985 7.98001 9.59985L7.02003 9.59985C6.62403 9.59985 6.30002 9.92385 6.30002 10.3199L6.30002 12.4799C6.30002 12.8759 6.62403 13.1999 7.02003 13.1999L7.98001 13.1999C8.37601 13.1999 8.70002 12.8759 8.70002 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3 5.3999L3 9.5999" stroke="white" stroke-width="0.875" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3 7.5L10.8 7.5C11.46 7.5 12 8.04 12 8.7L12 9.6" stroke="white"
                              stroke-width="0.875" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M7.5 7.5L7.5 9.6" stroke="white" stroke-width="0.875" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M13.2 12.4799L13.2 10.3199C13.2 9.92385 12.876 9.59985 12.48 9.59985L11.52 9.59985C11.124 9.59985 10.8 9.92385 10.8 10.3199L10.8 12.4799C10.8 12.8759 11.124 13.1999 11.52 13.1999L12.48 13.1999C12.876 13.1999 13.2 12.8759 13.2 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg></span>
                        <h3 (click)="handleRemoveSubBlock()">{{
                          'header.navigation.subMenus.solutions.items.useCases.title' | translate }}</h3>
                      </a>

                      <div class="commonTxtDiv">
                        <a [routerLink]="['/use-cases']" fragment="industries">

                          <div (click)="handleRemoveSubBlock()" class="linkMain2">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.industries.title' |
                              translate }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.industries.description' |
                              translate }}</p>
                          </div>
                        </a>
                        <a [routerLink]="['/use-cases']" fragment="job-function">
                          <div (click)="handleRemoveSubBlock()" class="linkMain2">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.jobFunctions.title' |
                              translate }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.jobFunctions.description' |
                              translate }}</p>
                          </div>
                        </a>



                      </div>
                    </div>
                  </div>

                  <div class="interfrationFloat1Row">
                    <a class="commonHeaderDivRow" routerLink="/integrations">
                      <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"
                          fill="none">
                          <path
                            d="M7.80601 1.75219L11.346 3.32419C12.366 3.77419 12.366 4.51819 11.346 4.96819L7.80601 6.54019C7.40401 6.72019 6.74401 6.72019 6.34201 6.54019L2.80201 4.96819C1.78201 4.51819 1.78201 3.77419 2.80201 3.32419L6.34201 1.75219C6.74401 1.57219 7.40401 1.57219 7.80601 1.75219Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M1.8 6.6001C1.8 7.1041 2.178 7.6861 2.64 7.8901L6.714 9.7021C7.026 9.8401 7.38 9.8401 7.686 9.7021L11.76 7.8901C12.222 7.6861 12.6 7.1041 12.6 6.6001"
                            stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1.8 9.6001C1.8 10.1581 2.13 10.6621 2.64 10.8901L6.714 12.7021C7.026 12.8401 7.38 12.8401 7.686 12.7021L11.76 10.8901C12.27 10.6621 12.6 10.1581 12.6 9.6001"
                            stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                        </svg></span>
                      <h3 (click)="handleRemoveSubBlock()">{{
                        'header.navigation.subMenus.solutions.items.integrations.title' | translate }}</h3>
                    </a>

                    <div class="commonTxtDiv">
                      <a [routerLink]="['/integrations']" fragment="business-platform">
                        <div (click)="handleRemoveSubBlock()" class="linkMain3">
                          <h2>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.businessPlatforms.title'
                            |
                            translate }}</h2>
                          <p>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.businessPlatforms.description'
                            | translate }}</p>
                        </div>
                      </a>

                      <!-- <div [routerLink]="['/integrations']" fragment="government-platform"
                        (click)="handleRemoveSubBlock()" class="linkMain3">
                        <h2>{{
                          'header.navigation.subMenus.solutions.items.integrations.platforms.governmentPlatforms.title'
                          | translate }}</h2>
                        <p>{{
                          'header.navigation.subMenus.solutions.items.integrations.platforms.governmentPlatforms.description'
                          | translate }}</p>
                      </div>  FOR FUTURE USE-->

                    </div>
                  </div>
                </div>

                <div class="bgmenuSubBgBottom">
                  <ul>
                    <li><a routerLink="/contact-us">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.contactUs' | translate }}</a></li>
                    <li><a routerLink='/demo' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.scheduleDemo' | translate }}</a></li>
                    <li><a routerLink='/product-tour' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.products.productTour' | translate
                        }}</a></li>
                        <li><a routerLink='/HR-Software'>{{
                        'header.navigation.subMenus.products.HRSoftware' | translate
                        }}</a></li>
                    <!-- <li><a>{{ 'header.navigation.subMenus.solutions.items.bottomLinks.learnMore' | translate }}</a></li> FUTURE USE-->
                  </ul>
                </div>
              </div>
            </li>
            <li class="top-level-link">


              <a (click)="handleRemoveSubBlock()" routerLink="/pricing"
                *ngIf="(translate.get('header.navigation.pricing') | async)"> {{ 'header.navigation.pricing' |
                translate }}</a>
              <a (click)="handleRemoveSubBlock()" routerLink="/pricing"
                *ngIf="!(translate.get('header.navigation.pricing') | async)"> Pricing</a>
            </li>

            <li class="top-level-link">
              <a class="mega-menu" (mouseenter)="handleViewSub('resource')">
                <span *ngIf="(translate.get('header.navigation.resources') | async)">{{ 'header.navigation.resources' |
                  translate }}
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>

                <span *ngIf="!(translate.get('header.navigation.resources') | async)">Resources
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>
              </a>
              <div *ngIf="resourceSubBlock" class="sub-menu-block">
                <div class="productsMenuDivRow2">
                  <div class="sub-menu-block subMenuWidthMain1">
                    <div class="productsMenuDivRow2">
                      <div class="linkFloatTxt">
                        <ul>
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/blog">{{
                              'header.navigation.subMenus.resources.items.blogs' | translate }}</a></li>
                          <!-- <li (click)="handleRemoveSubBlock()"><a [routerLink]="['/client-stories']">{{
                          'header.navigation.subMenus.resources.items.clientStories' | translate }}</a></li>  HIDING THIS PAGE FUTURE USE-->
                          <!-- <li (click)="handleRemoveSubBlock()"><a [routerLink]="['/product-demo']">{{
                          'header.navigation.subMenus.resources.items.productVideos' | translate }}</a></li> HIDING THIS PAGE FUTURE USE-->
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/hr-glossary">{{
                              'header.navigation.subMenus.resources.items.hrGlossary' | translate }}</a></li>

                          <li (click)="handleRemoveSubBlock()"><a
                              onclick="sessionStorage.setItem('old_page', window.location.pathname)"
                              routerLink="/resources/hr-templates">{{
                              'header.navigation.subMenus.resources.items.hrTemplates' | translate }}</a></li>
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/faq">{{
                          'header.navigation.subMenus.resources.items.faq' | translate }}</a></li>

                          <li (click)="handleRemoveSubBlock()"><a routerLink="/gratuity-calculator">{{
                              'header.navigation.subMenus.resources.items.gratuitycalculator' | translate }}</a></li>
                        </ul>
                      </div>

                      <div class="addBannerMain" [ngStyle]="{'cursor': 'pointer'}">
                        <!-- REMOVED [routerLink]="['/resources']" from addBannerMain for FUTURE USE -->
                        <h3>{{ 'header.navigation.subMenus.resources.banner.title' | translate }}</h3>
                        <!-- <button class="learnMoreBtn"> FOR FUTURE USE
                      <i [routerLink]="['/resources']" (click)="handleRemoveSubBlock()">{{ 'header.buttons.allResources'
                        | translate }}</i>
                      <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                          fill="none">
                          <path d="M4.1202 11.6104L18.2869 11.6104" stroke="white" stroke-width="1.66667"
                            stroke-linecap="round"></path>
                          <path d="M13.0013 17.7285L19.1206 11.6092L13.0259 5.51447" stroke="white"
                            stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg></span>
                    </button> -->

                        <label [ngStyle]="{'cursor': 'pointer'}">
                          <!-- //[routerLink]="['/resources']" FUTURE USE -->
                          <img [src]="'header.navigation.subMenus.resources.banner.bgImg' | translate" alt="img"
                            loading="lazy" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="bgmenuSubBgBottom">
                  <ul>
                    <li><a routerLink="/contact-us">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.contactUs' | translate }}</a></li>
                    <li><a routerLink='/demo' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.scheduleDemo' | translate }}</a></li>
                    <li><a routerLink='/product-tour' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.products.productTour' | translate
                        }}</a></li>

                    <li><a routerLink='/HR-Software'>{{
                        'header.navigation.subMenus.products.HRSoftware' | translate
                        }}</a></li>
                    <!-- <li><a>{{ 'header.navigation.subMenus.solutions.items.bottomLinks.learnMore' | translate }}</a></li> FUTURE USE-->
                  </ul>
                </div>
              </div>
            </li>





            <li class="top-level-link">
              <a class="mega-menu" (mouseenter)="handleViewSub('solution')">
                <span *ngIf="(translate.get('header.navigation.aboutUs') | async)">
                  {{ 'header.navigation.aboutUs' | translate }}
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>
                <span *ngIf="!(translate.get('header.navigation.aboutUs') | async)">About Us
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame 1691">
                      <path id="Vector 208" d="M3.39233 7.50391L8.39624 12.5078L13.4001 7.50391" stroke="white"
                        stroke-width="1.4" stroke-linecap="round" />
                    </g>
                  </svg>
                </span>
              </a>

              <div *ngIf="solutionSubBlock" class="sub-menu-block">
                <div class="productsMenuDivRow2">
                  <!-- Existing About Us Section -->
                  <div *ngIf="aboutUsSubBlock" class="sub-menu-block subMenuWidthMain1">
                    <div class="productsMenuDivRow2">
                      <div class="linkFloatTxt">
                        <ul>
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/about-us">{{
                              'header.navigation.subMenus.aboutUs.items.aboutUs' | translate }}</a></li>
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/contact-us">{{
                              'header.navigation.subMenus.aboutUs.items.contactUs' | translate }}</a></li>
                          <li style="font-size: 10 !important;" (click)="handleRemoveSubBlock()"><a
                              routerLink="/partner-program">{{
                              'header.navigation.subMenus.aboutUs.items.partnersprogram' | translate }}</a></li>
                          <li (click)="handleRemoveSubBlock()"><a routerLink="/newsroom">{{
                              'header.navigation.subMenus.aboutUs.items.newsroom' | translate }}</a></li>
                        </ul>
                      </div>

                      <a routerLink="/contact-us">
                        <div class="addBannerMain1">
                          <h3>{{ 'header.navigation.subMenus.aboutUs.banner.title' | translate }}</h3>
                          <p>
                            {{ 'header.navigation.subMenus.aboutUs.banner.description' | translate }}
                          </p>
                          <button class="learnMoreBtn">
                            <i>{{ 'header.buttons.getInTouch' | translate }}</i>
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M4.1202 11.6104L18.2869 11.6104" stroke="white" stroke-width="1.66667"
                                  stroke-linecap="round"></path>
                                <path d="M13.0013 17.7285L19.1206 11.6092L13.0259 5.51447" stroke="white"
                                  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                              </svg>
                            </span>
                          </button>

                          <label style="cursor: pointer;">
                            <img [src]="'header.navigation.subMenus.aboutUs.banner.bgImg' | translate" alt="img"
                              loading="lazy" />
                          </label>
                        </div>
                      </a>
                    </div>
                  </div>

                  <!-- New List & Banner Section -->
                  <div class="productsMenuDivRow2">
                    <div class="linkFloatTxt">
                      <ul>
                        <li (click)="handleRemoveSubBlock()"><a routerLink="/about-us">{{
                            'header.navigation.subMenus.aboutUs.items.aboutUs' | translate }}</a></li>
                        <li (click)="handleRemoveSubBlock()"><a routerLink="/contact-us">{{
                            'header.navigation.subMenus.aboutUs.items.contactUs' | translate }}</a></li>
                        <li style="font-size: 10 !important;" (click)="handleRemoveSubBlock()"><a
                            routerLink="/partner-program">{{
                            'header.navigation.subMenus.aboutUs.items.partnersprogram' | translate }}</a></li>
                        <li (click)="handleRemoveSubBlock()"><a routerLink="/newsroom">{{
                            'header.navigation.subMenus.aboutUs.items.newsroom' | translate }}</a></li>
                      </ul>
                    </div>

                    <a routerLink="/contact-us">
                      <div class="addBannerMain1">
                        <h3>{{ 'header.navigation.subMenus.aboutUs.banner.title' | translate }}</h3>
                        <p>
                          {{ 'header.navigation.subMenus.aboutUs.banner.description' | translate }}
                        </p>
                        <button class="learnMoreBtn">
                          <i>{{ 'header.buttons.getInTouch' | translate }}</i>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none">
                              <path d="M4.1202 11.6104L18.2869 11.6104" stroke="white" stroke-width="1.66667"
                                stroke-linecap="round"></path>
                              <path d="M13.0013 17.7285L19.1206 11.6092L13.0259 5.51447" stroke="white"
                                stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                          </span>
                        </button>

                        <label style="cursor: pointer;">
                          <img [src]="'header.navigation.subMenus.aboutUs.banner.bgImg' | translate" alt="img"
                            loading="lazy" />
                        </label>
                      </div>
                    </a>
                  </div>


                </div>
                <div class="bgmenuSubBgBottom">
                  <ul>
                    <li><a routerLink="/contact-us">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.contactUs' | translate }}</a></li>
                    <li><a routerLink='/demo' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.solutions.items.bottomLinks.scheduleDemo' | translate }}</a></li>
                    <li><a routerLink='/product-tour' onclick="sessionStorage.setItem('previous_page', 'header')">{{
                        'header.navigation.subMenus.products.productTour' | translate
                        }}</a></li>
                    <li><a routerLink='/HR-Software'>{{
                        'header.navigation.subMenus.products.HRSoftware' | translate
                        }}</a></li>
                  </ul>
                </div>
              </div>
            </li>

          </ul>
        </nav>
      </div>

      <div class="loginDivFlexRow">
        <div class="languageDropDownDiv">
          <div class="dropdown-hover web">
            <button class="dropdown-toggle" type="button" *ngIf="(translate.get('en') | async)">
              {{en}}
              <svg class="dropSvg" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                fill="none">
                <path d="M3.39408 6.74166L7.63672 10.9843L11.8794 6.74166" stroke="white" stroke-width="1.4"
                  stroke-linecap="round" />
              </svg>
            </button>

            <button class="dropdown-toggle" type="button" *ngIf="!(translate.get('en') | async)">
              EN
              <svg class="dropSvg" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                fill="none">
                <path d="M3.39408 6.74166L7.63672 10.9843L11.8794 6.74166" stroke="white" stroke-width="1.4"
                  stroke-linecap="round" />
              </svg>
            </button>
            <ul class="dropdown-menu-hover">
              <li><a class="dropdown-item" (click)="setLang('EN')" [ngClass]="en=='EN'?'highlight':''">EN</a></li>
              <li><a class="dropdown-item" (click)="setLang('AR')" [ngClass]="en=='AR'?'highlight':''">AR</a></li>
            </ul>
          </div>

          <div class="dropdown mobile">
            <button class="btn btn-secondary dropdown-toggle" [class.show]="didScroll" type="button"
              data-bs-toggle="dropdown" (click)="langDrop()" aria-expanded="false">
              {{en}}
            </button>
            <ul class="dropdown-menu" [class.show]="didScroll">
              <li><a class="dropdown-item" (click)="setLang('EN')" [ngClass]="en=='EN'?'highlight':''">EN</a></li>
              <li><a class="dropdown-item" (click)="setLang('AR')" [ngClass]="en=='AR'?'highlight':''">AR</a></li>
            </ul>
          </div>

        </div>
        <a dir="ltr" href="https://app.infithra.com/auth/login" target="_blank">
          <button class="loginMainBtn">
            <i *ngIf="(translate.get('header.buttons.logIn') | async)">{{ 'header.buttons.logIn' | translate }}</i>
            <i *ngIf="!(translate.get('header.buttons.logIn') | async)">Log In</i>
            <span><svg class="desktopLoginBlog" xmlns="http://www.w3.org/2000/svg" width="20" height="21"
                viewBox="0 0 20 21" fill="none">
                <path
                  d="M9.9974 9.69033C11.0391 9.69033 11.8836 8.84584 11.8836 7.80412C11.8836 6.76241 11.0391 5.91797 9.9974 5.91797C8.95568 5.91797 8.11121 6.76241 8.11121 7.80412C8.11121 8.84584 8.95568 9.69033 9.9974 9.69033Z"
                  stroke="#241042" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M13.2358 14.2723C13.2358 12.8152 11.7868 11.6333 9.99774 11.6333C8.20869 11.6333 6.75964 12.8152 6.75964 14.2723"
                  stroke="#241042" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <img width="96" height="97" class="desktopLoginBlogBlue" alt="img" src="../../assets/images/login_icon.webp" />
            </span>
          </button>
        </a>


        <button class="mobileMenuMain" type="button" (click)="setOffcanvas(true)" aria-label="menu">
          <img width="17" height="15" alt="Menu icon" src="../../assets/images/menu-toogle.svg" />
        </button>

        <button class="mobileMenuMain1" type="button" (click)="setOffcanvas(true)" aria-label="menu">
          <img width="51" height="43" alt="Menu icon" src="../../assets/images/menu-toogle1.png" />
        </button>

        <div class="offcanvas offcanvas-end" [ngClass]="{'show':offcanvasBoolean}" tabindex="-1" id="offcanvasTop"
          aria-labelledby="offcanvasTopLabel" data-bs-scroll="false" data-bs-backdrop="false">
          <div class="offcanvas-header">
            <a routerLink="/" (click)="setOffcanvas(false)">
              <div style="max-width: 110px;">

                <div class="headerltr">
                  <img width="453" height="113" src="../../assets/images/infinthra-bluetext-logo.webp" alt="">
                </div>
                <div class="headerrtl">
                  <img src="../../assets/images/infinthra-bluetext-logo-ar-new.svg" alt="">
                </div>
              </div>
            </a>
            <div class="offcanvas-title" id="offcanvasExampleLabel">
              <div class="languageDropDownDiv">
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false" dir="ltr">
                    {{en}}


                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" (click)="setLang('EN')" [ngClass]="en=='EN'?'highlight':''">EN</a></li>
                    <li><a class="dropdown-item" (click)="setLang('AR')" [ngClass]="en=='AR'?'highlight':''">AR</a></li>

                  </ul>
                </div>
              </div>
              <button (click)="setOffcanvas(false)" type="button" class="btn-close text-reset"
                data-bs-dismiss="offcanvas" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <rect width="16.9474" height="2" rx="1"
                    transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 13.6021 12.3192)" fill="#361863" />
                  <rect x="0.602051" y="12.3192" width="16.9474" height="2" rx="1"
                    transform="rotate(-45 0.602051 12.3192)" fill="#361863" />
                </svg>
              </button>
            </div>
          </div>
          <div class="offcanvas-body">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header rtlAccordion" id="headingOne">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    {{ 'header.mobileMenu.accordion.products' | translate }}
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <a class="iconWrapperMainFlex1" routerLink="/core-hr" (click)="setOffcanvas(false)">
                      <div class="iconWrapper1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M11.1667 9.4671V4.08377C11.1667 3.46044 10.6567 2.95044 10.0334 2.95044H7.4834"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M8.90019 1.53369L7.2002 2.95036L8.90019 4.36702" stroke="white" stroke-width="0.9375"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M3.2334 5.50049V9.46715" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.37511 5.21702C4.39224 5.21702 5.21678 4.39248 5.21678 3.37536C5.21678 2.35823 4.39224 1.53369 3.37511 1.53369C2.35799 1.53369 1.53345 2.35823 1.53345 3.37536C1.53345 4.39248 2.35799 5.21702 3.37511 5.21702Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.23345 12.867C4.17233 12.867 4.93345 12.1059 4.93345 11.167C4.93345 10.2282 4.17233 9.46704 3.23345 9.46704C2.29456 9.46704 1.53345 10.2282 1.53345 11.167C1.53345 12.1059 2.29456 12.867 3.23345 12.867Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M11.1668 12.867C12.1057 12.867 12.8668 12.1059 12.8668 11.167C12.8668 10.2282 12.1057 9.46704 11.1668 9.46704C10.2279 9.46704 9.4668 10.2282 9.4668 11.167C9.4668 12.1059 10.2279 12.867 11.1668 12.867Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div class="iconWrapper1Text">
                        <h2>{{ 'header.navigation.subMenus.products.items.coreHR.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.coreHR.description' | translate }}</p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex2" routerLink="/employee-management" (click)="setOffcanvas(false)">
                      <div class="iconWrapper2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <circle cx="7.19975" cy="7.2" r="6.73125" fill="white" fill-opacity="0.22" stroke="white"
                            stroke-width="0.9375" />
                          <path
                            d="M7.19933 6.47993C8.12584 6.47993 8.87693 5.72884 8.87693 4.80232C8.87693 3.87581 8.12584 3.12476 7.19933 3.12476C6.27282 3.12476 5.52173 3.87581 5.52173 4.80232C5.52173 5.72884 6.27282 6.47993 7.19933 6.47993Z"
                            fill="#81B2FF" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M10.0796 10.5554C10.0796 9.25941 8.79078 8.20825 7.19958 8.20825C5.60838 8.20825 4.31958 9.25941 4.31958 10.5554"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div [routerLink]="['/employee-management']" class="iconWrapper1Text"
                        (click)="setOffcanvas(false)">
                        <h2>{{ 'header.navigation.subMenus.products.items.employeeManagement.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.employeeManagement.description' | translate }}
                        </p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex3" routerLink="/attendance-management" (click)="setOffcanvas(false)">
                      <div class="iconWrapper3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M13.2002 7.69995C13.2002 11.0119 10.5122 13.6999 7.20019 13.6999C3.88819 13.6999 1.2002 11.0119 1.2002 7.69995C1.2002 4.38795 3.88819 1.69995 7.20019 1.69995C10.5122 1.69995 13.2002 4.38795 13.2002 7.69995Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M9.42627 9.6081L7.56627 8.4981C7.24227 8.3061 6.97827 7.8441 6.97827 7.4661V5.0061"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div a routerLink="/attendance-management" class="iconWrapper1Text">
                        <h2>{{ 'header.navigation.subMenus.products.items.timeAttendance.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.timeAttendance.description' | translate }}</p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex4" routerLink="/leave-management" (click)="setOffcanvas(false)">
                      <div class="iconWrapper4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M12.5998 5.59961V10.6996C12.5998 12.4996 11.6998 13.6996 9.5998 13.6996H4.7998C2.6998 13.6996 1.7998 12.4996 1.7998 10.6996V5.59961C1.7998 3.79961 2.6998 2.59961 4.7998 2.59961H9.5998C11.6998 2.59961 12.5998 3.79961 12.5998 5.59961Z"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M12.5998 5.59985V10.6998C12.5998 12.4998 11.6998 13.6998 9.5998 13.6998H4.7998C2.6998 13.6998 1.7998 12.4998 1.7998 10.6998V5.59985C1.7998 3.79985 2.6998 2.59985 4.7998 2.59985H9.5998C11.6998 2.59985 12.5998 3.79985 12.5998 5.59985Z"
                            stroke="white" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M2.1001 5.9541H12.3001" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.7998 1.7002V3.50019" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.6001 1.7002V3.50019" stroke="white" stroke-width="0.9375" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.41682 8.71992H9.42221" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M9.41682 10.52H9.42221" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M7.19709 8.71992H7.20248" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M7.19709 10.52H7.20248" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.97639 8.71992H4.98178" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M4.97639 10.52H4.98178" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div a routerLink="/leave-management" class="iconWrapper1Text">
                        <h2>{{ 'header.navigation.subMenus.products.items.leaveManagement.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.leaveManagement.description' | translate }}</p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex5" a routerLink="/payroll-management" (click)="setOffcanvas(false)">
                      <div class="iconWrapper5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M10.8235 8.63014C10.5715 8.87614 10.4275 9.23014 10.4635 9.60814C10.5175 10.2561 11.1115 10.7301 11.7595 10.7301H12.8995V11.4441C12.8995 12.6861 11.8855 13.7001 10.6435 13.7001H3.75551C2.51351 13.7001 1.49951 12.6861 1.49951 11.4441V7.40615C1.49951 6.16415 2.51351 5.15015 3.75551 5.15015H10.6435C11.8855 5.15015 12.8995 6.16415 12.8995 7.40615V8.27015H11.6875C11.3515 8.27015 11.0455 8.40214 10.8235 8.63014Z"
                            fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M1.49951 7.94618V5.20421C1.49951 4.49021 1.93751 3.85418 2.60351 3.60218L7.36751 1.80218C8.11151 1.52018 8.90951 2.0722 8.90951 2.8702V5.15019"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M13.5347 8.88199V10.118C13.5347 10.448 13.2707 10.718 12.9347 10.73H11.7587C11.1107 10.73 10.5167 10.256 10.4627 9.60801C10.4267 9.23001 10.5707 8.876 10.8227 8.63C11.0447 8.402 11.3507 8.27002 11.6867 8.27002H12.9347C13.2707 8.28202 13.5347 8.55199 13.5347 8.88199Z"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.19946 7.69995H8.39946" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div a routerLink="/payroll-management" class="iconWrapper1Text">
                        <h2>{{ 'header.navigation.subMenus.products.items.payrollManagement.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.payrollManagement.description' | translate }}
                        </p>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex6" routerLink="/people-analytics" (click)="setOffcanvas(false)">
                      <div class="iconWrapper6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                          <path
                            d="M11.5559 11.8398V4.75976C11.5559 3.85976 11.1719 3.49976 10.2179 3.49976H9.59386C8.63986 3.49976 8.25586 3.85976 8.25586 4.75976V11.8398"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M11.5559 11.8398V4.75976C11.5559 3.85976 11.1719 3.49976 10.2179 3.49976H9.59386C8.63986 3.49976 8.25586 3.85976 8.25586 4.75976V11.8398"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M3.15576 11.8402V7.76024C3.15576 6.86024 3.53976 6.50024 4.49376 6.50024H5.11776C6.07176 6.50024 6.45576 6.86024 6.45576 7.76024V11.8402"
                            fill="white" fill-opacity="0.22" />
                          <path
                            d="M3.15576 11.8402V7.76024C3.15576 6.86024 3.53976 6.50024 4.49376 6.50024H5.11776C6.07176 6.50024 6.45576 6.86024 6.45576 7.76024V11.8402"
                            stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1.2002 11.9001H13.2002" stroke="white" stroke-width="0.9375" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div class="iconWrapper1Text">
                        <h2>{{ 'header.navigation.subMenus.products.items.peopleAnalytics.title' | translate }}</h2>
                        <p>{{ 'header.navigation.subMenus.products.items.peopleAnalytics.description' | translate }}</p>
                      </div>
                    </a>
                     <a class="iconWrapperMainFlex8" href=" " (click)="isDisabled ? $event.preventDefault() : null">

                      <div class="iconWrapperMainFlex8">
                        <div class="iconWrapper8">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M6.2 14H9.8C12.8 14 14 12.8 14 9.8V6.2C14 3.2 12.8 2 9.8 2H6.2C3.2 2 2 3.2 2 6.2V9.8C2 12.8 3.2 14 6.2 14Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.22156 6.12793H11.3716H8.22156Z" fill="white" fill-opacity="0.22" />
                            <path d="M8.22156 6.12793H11.3716" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.6283 6.12778L5.0783 6.57778L6.4283 5.22778" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.22156 10.3279H11.3716H8.22156Z" fill="white" fill-opacity="0.22" />
                            <path d="M8.22156 10.3279H11.3716" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.6283 10.328L5.0783 10.778L6.4283 9.42798" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div class="iconWrapper1Text" (click)="setOffcanvas(false)">
                          <h3 class="head"><span>{{
                              'header.navigation.subMenus.products.items.performanceManagement.title' | translate
                              }}</span>
                            <!-- <sup class="sup">{{ 'header.navigation.subMenus.products.items.performanceManagement.sup' |
                              translate
                              }}</sup> -->
                          </h3>
                          <p>{{ 'header.navigation.subMenus.products.items.performanceManagement.description' |
                            translate
                            }}</p>
                        </div>
                      </div>
                    </a>

                    <a class="iconWrapperMainFlex7" href=" ">

                      <div class="iconWrapperMainFlex7">
                        <div class="iconWrapper7">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"
                            fill="none">
                            <path
                              d="M10.8002 4.79595C10.7642 4.78995 10.7222 4.78995 10.6862 4.79595C9.85824 4.76595 9.19824 4.08795 9.19824 3.24795C9.19824 2.38995 9.88824 1.69995 10.7462 1.69995C11.6042 1.69995 12.2942 2.39595 12.2942 3.24795C12.2882 4.08795 11.6282 4.76595 10.8002 4.79595Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M10.1822 9.16405C11.0042 9.30205 11.9102 9.15805 12.5462 8.73205C13.3922 8.16805 13.3922 7.24405 12.5462 6.68005C11.9042 6.25405 10.9862 6.11004 10.1642 6.25404"
                              fill="white" fill-opacity="0.22" />
                            <path
                              d="M10.1822 9.16405C11.0042 9.30205 11.9102 9.15805 12.5462 8.73205C13.3922 8.16805 13.3922 7.24405 12.5462 6.68005C11.9042 6.25405 10.9862 6.11004 10.1642 6.25404"
                              stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M3.58226 4.79595C3.61826 4.78995 3.66026 4.78995 3.69626 4.79595C4.52426 4.76595 5.18426 4.08795 5.18426 3.24795C5.18426 2.38995 4.49426 1.69995 3.63626 1.69995C2.77826 1.69995 2.08826 2.39595 2.08826 3.24795C2.09426 4.08795 2.75426 4.76595 3.58226 4.79595Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M4.20016 9.16405C3.37816 9.30205 2.47216 9.15805 1.83616 8.73205C0.99016 8.16805 0.99016 7.24405 1.83616 6.68005C2.47816 6.25405 3.39616 6.11004 4.21816 6.25404"
                              fill="white" fill-opacity="0.22" />
                            <path
                              d="M4.20016 9.16405C3.37816 9.30205 2.47216 9.15805 1.83616 8.73205C0.99016 8.16805 0.99016 7.24405 1.83616 6.68005C2.47816 6.25405 3.39616 6.11004 4.21816 6.25404"
                              stroke="white" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M7.20026 9.27789C7.16426 9.27189 7.12227 9.27189 7.08627 9.27789C6.25827 9.24789 5.59827 8.56989 5.59827 7.72989C5.59827 6.87189 6.28827 6.18188 7.14626 6.18188C8.00426 6.18188 8.69427 6.87789 8.69427 7.72989C8.68827 8.56989 8.02826 9.25389 7.20026 9.27789Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M5.4542 11.1679C4.6082 11.7319 4.6082 12.6559 5.4542 13.2199C6.4142 13.8619 7.9862 13.8619 8.9462 13.2199C9.7922 12.6559 9.7922 11.7319 8.9462 11.1679C7.9922 10.5319 6.4142 10.5319 5.4542 11.1679Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.9375"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div class="iconWrapper1Text" (click)="setOffcanvas(false)">
                          <h3>{{ 'header.navigation.subMenus.products.items.recruitment.title' | translate }} <sup>{{
                              'header.navigation.subMenus.products.items.recruitment.sup' | translate }}</sup></h3>
                          <p>{{ 'header.navigation.subMenus.products.items.recruitment.description' | translate }}</p>
                        </div>
                      </div>
                    </a>
                   
                    <a routerLink="/employee-self-service">
                      <div class="ess-banner">
                        <img class="patternPosBottom" alt="pattern" width="100%"
                          src="../../assets/images/header-Ess-banner.svg" />
                        <div class="ess-banner-content">
                          <h2>{{ 'header.navigation.subMenus.products.essBanner.title' | translate }}</h2>
                        </div>
                        <img src="../../assets/images/infithra-employee-self-service-app.svg" alt="Mascot"
                          class="ess-banner-image">
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header rtlAccordion" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    {{ 'header.mobileMenu.accordion.solutions' | translate }}
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="bussinessCaseDiv" [routerLink]="['/use-cases']" fragment='business-size'>
                      <div class="commonHeaderDivRow">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                            fill="none">
                            <path
                              d="M7.80001 13.2H3.00001C1.80001 13.2 1.20001 12.6 1.20001 11.4V6.60005C1.20001 5.40005 1.80001 4.80005 3.00001 4.80005H6.00001V11.4C6.00001 12.6 6.60001 13.2 7.80001 13.2Z"
                              stroke="white" stroke-width="0.88" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path
                              d="M6.06599 2.3999C6.01799 2.5799 6 2.7779 6 2.9999V4.7999H3V3.5999C3 2.9399 3.54 2.3999 4.2 2.3999H6.06599Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.40002 4.80005V7.80005" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.8 4.80005V7.80005" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.60004 7.80005V10.2" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M6 11.4V2.99995C6 1.79995 6.6 1.19995 7.8 1.19995H11.4C12.6 1.19995 13.2 1.79995 13.2 2.99995V11.4C13.2 12.6 12.6 13.2 11.4 13.2H7.8C6.6 13.2 6 12.6 6 11.4Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M10.2 10.2H9.00002C8.67002 10.2 8.40002 10.47 8.40002 10.8V13.2H10.8V10.8C10.8 10.47 10.53 10.2 10.2 10.2Z"
                              fill="#3A86FF" stroke="white" stroke-width="0.88" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg></span>
                        <h3 [routerLink]="['/use-cases']" (click)="setOffcanvas(false)">
                          <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.title' | translate }}</h2>
                        </h3>
                      </div>

                      <div class="commonTxtDiv">
                        <div class="linkMain1" [routerLink]="['/use-cases']" fragment='business-size'
                          (click)="setOffcanvas(false)">
                          <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.startups.title' |
                            translate }}</h2>
                          <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.startups.description' |
                            translate }}</p>
                        </div>
                        <a [routerLink]="['/use-cases']" fragment='business-size'>
                          <div class="linkMain1" (click)="setOffcanvas(false)">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.smes.title' |
                              translate
                              }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.smes.description' |
                              translate }}</p>
                          </div>
                        </a>
                        <a [routerLink]="['/use-cases']" fragment='business-size'>
                          <div class="linkMain1" (click)="setOffcanvas(false)">
                            <h2>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.enterprise.title' |
                              translate }}</h2>
                            <p>{{ 'header.navigation.subMenus.solutions.items.businessSize.cases.enterprise.description'
                              |
                              translate }}</p>
                          </div>
                        </a>
                      </div>
                    </div>

                    <div class="userCaseDiv">
                      <div class="commonHeaderDivRow">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                            fill="none">
                            <path
                              d="M4.80001 4.19995L4.80001 2.39995C4.80001 1.73995 4.26001 1.19995 3.60001 1.19995L2.40001 1.19995C1.74001 1.19995 1.20001 1.73995 1.20001 2.39995L1.20001 4.19995C1.20001 4.85995 1.74001 5.39995 2.40001 5.39995L3.60001 5.39995C4.26001 5.39995 4.80001 4.85995 4.80001 4.19995Z"
                              stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M4.20002 12.4799L4.20002 10.3199C4.20002 9.92385 3.87601 9.59985 3.48001 9.59985L2.52003 9.59985C2.12403 9.59985 1.80002 9.92385 1.80002 10.3199L1.80002 12.4799C1.80002 12.8759 2.12403 13.1999 2.52003 13.1999L3.48001 13.1999C3.87601 13.1999 4.20002 12.8759 4.20002 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M8.70002 12.4799L8.70002 10.3199C8.70002 9.92385 8.37601 9.59985 7.98001 9.59985L7.02003 9.59985C6.62403 9.59985 6.30002 9.92385 6.30002 10.3199L6.30002 12.4799C6.30002 12.8759 6.62403 13.1999 7.02003 13.1999L7.98001 13.1999C8.37601 13.1999 8.70002 12.8759 8.70002 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3 5.3999L3 9.5999" stroke="white" stroke-width="0.875" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3 7.5L10.8 7.5C11.46 7.5 12 8.04 12 8.7L12 9.6" stroke="white"
                              stroke-width="0.875" stroke-miterlimit="10" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M7.5 7.5L7.5 9.6" stroke="white" stroke-width="0.875" stroke-miterlimit="10"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M13.2 12.4799L13.2 10.3199C13.2 9.92385 12.876 9.59985 12.48 9.59985L11.52 9.59985C11.124 9.59985 10.8 9.92385 10.8 10.3199L10.8 12.4799C10.8 12.8759 11.124 13.1999 11.52 13.1999L12.48 13.1999C12.876 13.1999 13.2 12.8759 13.2 12.4799Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg></span>
                        <a routerLink="/use-cases">
                          <h3 (click)="setOffcanvas(false)">{{
                            'header.navigation.subMenus.solutions.items.useCases.title' | translate }}</h3>
                        </a>
                      </div>

                      <div class="commonTxtDiv">
                        <div class="linkMain2" [routerLink]="['/use-cases']" fragment="industries"
                          (click)="setOffcanvas(false)">
                          <h2>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.industries.title' |
                            translate }}</h2>
                          <p>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.industries.description' |
                            translate }}</p>
                        </div>
                        <div class="linkMain2" [routerLink]="['/use-cases']" fragment="job-function"
                          (click)="setOffcanvas(false)">
                          <h2>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.jobFunctions.title' |
                            translate }}</h2>
                          <p>{{ 'header.navigation.subMenus.solutions.items.useCases.cases.jobFunctions.description' |
                            translate }}</p>
                        </div>


                      </div>
                    </div>

                    <div class="interfrationFloat1Row">
                      <div class="commonHeaderDivRow">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"
                            fill="none">
                            <path
                              d="M7.80601 1.75219L11.346 3.32419C12.366 3.77419 12.366 4.51819 11.346 4.96819L7.80601 6.54019C7.40401 6.72019 6.74401 6.72019 6.34201 6.54019L2.80201 4.96819C1.78201 4.51819 1.78201 3.77419 2.80201 3.32419L6.34201 1.75219C6.74401 1.57219 7.40401 1.57219 7.80601 1.75219Z"
                              fill="white" fill-opacity="0.22" stroke="white" stroke-width="0.875"
                              stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M1.8 6.6001C1.8 7.1041 2.178 7.6861 2.64 7.8901L6.714 9.7021C7.026 9.8401 7.38 9.8401 7.686 9.7021L11.76 7.8901C12.222 7.6861 12.6 7.1041 12.6 6.6001"
                              stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M1.8 9.6001C1.8 10.1581 2.13 10.6621 2.64 10.8901L6.714 12.7021C7.026 12.8401 7.38 12.8401 7.686 12.7021L11.76 10.8901C12.27 10.6621 12.6 10.1581 12.6 9.6001"
                              stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
                          </svg></span>
                        <a routerLink="/integrations">
                          <h3 (click)="setOffcanvas(false)">{{
                            'header.navigation.subMenus.solutions.items.integrations.title' | translate }}</h3>
                        </a>
                      </div>

                      <div class="commonTxtDiv">
                        <div class="linkMain3" [routerLink]="['/integrations']" fragment="business-platform"
                          (click)="setOffcanvas(false)">
                          <h2>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.businessPlatforms.title'
                            | translate }}</h2>
                          <p>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.businessPlatforms.description'
                            | translate }}</p>
                        </div>

                        <!-- <div class="linkMain3" [routerLink]="['/integrations']" fragment="government-platform"
                          (click)="setOffcanvas(false)">
                          <h2>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.governmentPlatforms.title'
                            | translate }}</h2>
                          <p>{{
                            'header.navigation.subMenus.solutions.items.integrations.platforms.governmentPlatforms.description'
                            | translate }}</p>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button [routerLink]="['/pricing']" (click)="setOffcanvas(false)" class="accordion-buttonMain"
                    type="button">
                    {{ 'header.mobileMenu.accordion.pricing' | translate }}
                  </button>
                </h2>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header rtlAccordion" id="heading5">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                    {{'header.mobileMenu.accordion.resources' | translate }}
                  </button>
                </h2>
                <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="linkFloatTxt">
                      <ul>
                        <li [routerLink]="['/blog']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.blogs' | translate }}</li>
                        <!-- <li [routerLink]="['/client-stories']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.clientStories' | translate }}</li> HIDING THIS PAGE FUTURE USE-->
                        <!-- <li [routerLink]="['/product-demo']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.productVideos' | translate }}</li> HIDING THIS PAGE FUTURE USE -->
                        <li [routerLink]="['/hr-glossary']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.hrGlossary' | translate }}</li>
                        <li onclick="sessionStorage.setItem('old_page', window.location.pathname)"
                          [routerLink]="['/resources/hr-templates']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.hrTemplates' | translate }}</li>
                        <li [routerLink]="['/faq']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.faq' | translate }}</li>
                        <li [routerLink]="['/gratuity-calculator']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.gratuitycalculator' | translate }}</li>
                        <!-- <li [routerLink]="['/help-center']" (click)="setOffcanvas(false)">{{
                          'header.navigation.subMenus.resources.items.helpCenter' | translate }}</li> FOR FUTURE USE -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header rtlAccordion" id="heading6">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                    {{ 'header.mobileMenu.accordion.aboutUs' | translate }}
                  </button>
                </h2>
                <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <div class="linkFloatTxt">
                      <ul>
                        <li [routerLink]="['/about-us']" (click)="setOffcanvas(false)">{{
                          'header.mobileMenu.accordion.aboutUs' | translate }}</li>
                        <li [routerLink]="['/contact-us']" (click)="setOffcanvas(false)">{{
                          'header.mobileMenu.accordion.contactUs' | translate }}</li>
                        <li [routerLink]="['/partner-program']" (click)="setOffcanvas(false)">{{
                          'header.mobileMenu.accordion.partnerProgram' | translate }}</li>
                        <li [routerLink]="['/newsroom']" (click)="setOffcanvas(false)">{{
                          'header.mobileMenu.accordion.newsroom' | translate }}</li>
                        <!-- <li [routerLink]="['/careers']" (click)="setOffcanvas(false)">Careers</li> -->
                        <!-- <li>{{ 'header.mobileMenu.accordion.newsroom' | translate }}</li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="menuBtnBottom">
              <button [routerLink]="['/demo']" (click)="setOffcanvas(false)" class="mobileMenuSecheduleDemoBtn"
                onclick="sessionStorage.setItem('previous_page', 'header')">
                {{ 'header.buttons.scheduleDemo' | translate }}
                <span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3.98326 9.77138L14.8003 9.77138" stroke="white" stroke-width="1.27259"
                      stroke-linecap="round" />
                    <path d="M10.7646 14.4433L15.437 9.77084L10.7833 5.11717" stroke="white" stroke-width="1.27259"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg></span>
              </button>
              <button (click)="navigateToExternal($event)" class="mobileLoginBtn" (click)="setOffcanvas(false)">
                {{ 'header.buttons.logIn' | translate }}
                <span><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                    <path
                      d="M13.066 12.0537C14.461 12.0537 15.5918 10.9229 15.5918 9.52795C15.5918 8.13302 14.461 7.00226 13.066 7.00226C11.6711 7.00226 10.5403 8.13302 10.5403 9.52795C10.5403 10.9229 11.6711 12.0537 13.066 12.0537Z"
                      stroke="white" stroke-width="1.33907" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M17.4025 18.1892C17.4025 16.238 15.4622 14.6554 13.0665 14.6554C10.6708 14.6554 8.73047 16.238 8.73047 18.1892"
                      stroke="white" stroke-width="1.33907" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>